<app-si-dialog
  header="Impersonate"
  [saveButtonDisabled]="impersonateForm.invalid"
  [saveButtonText]="isimpersonateHaveValue ? 'Clear' : 'Submit'"
>
  <ng-template appDialogBody>
    <div class="p-12">

    </div>
  </ng-template>
</app-si-dialog>
